import { render, staticRenderFns } from "./Bando28Fase5.vue?vue&type=template&id=5314d954&scoped=true"
import script from "./Bando28Fase5.vue?vue&type=script&lang=js"
export * from "./Bando28Fase5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5314d954",
  null
  
)

export default component.exports